import loadable from '@loadable/component';
import { LOADABLE_NO_SSR } from 'shared/utils/loadable';

export const ElectronicTradingWidgetLoadable = loadable.lib(() => import('@cian/frontend-electronic-trading-widget'), {
  ...LOADABLE_NO_SSR,
});

ElectronicTradingWidgetLoadable.displayName = 'ElectronicTradingWidgetLoadable';
